// What the Workspace documents part's REST answers (the screen imports these
// from `@trameria/cloud-api/workspace-documents-shared`).
import type { PageListItemDTO } from "@trameria/core/documents-shared";

/** A workspace's document in a list: the document, and the space it is in. */
export interface WsPageView extends PageListItemDTO {
  spaceId: string;
}

export interface WsPageList {
  pages: WsPageView[];
  nextCursor: string | null;
}

/** Where a workspace's document lives. */
export interface WsPagePlace {
  pageId: string;
  workspace: { id: string; slug: string; name: string };
  space: { id: string; slug: string; name: string };
}

/** Core events this part records (to those who see the document's space). */
export interface WorkspaceDocumentEvents {
  /** The document moved to another space of its workspace. */
  "page.moved": { id: string; spaceId: string };
}

/** The permission and the feature of workspace documents. */
export const PAGE_WRITE = "page.write";
export const DOCUMENT_FEATURE = "document";

/**
 * Paths of a workspace's documents a URL names one by (`:slug` any workspace's,
 * `:key` the document's; an index's document is the last key). Written or
 * pasted, such a URL becomes a reference.
 */
export const WORKSPACE_DOCUMENT_REF_PATHS = [
  "/:slug/documents/:key",
  "/:slug/documents/:key/*",
  "/:slug/documents/index/:key",
  "/:slug/documents/index/:index/:key",
] as const;
